import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, capitalize, capitalizeWord } from './format'

export function newTimesheet(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_TIMESHEET_START", payload: "" })
            
            console.log("new Timesheet START", {data})
            const res = await axios.post('/timesheets/new',{data})
            console.log({res});
                        
            if (checkErrorData(res, "CREATE_TIMESHEET_ERROR", dispatch ) ) {
				dispatch({ type: "NEW_TIMESHEET", payload: res.data })
				dispatch({ type: "CREATE_TIMESHEET_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new timesheet ", err);
            dispatch({
                type: "CREATE_TIMESHEET_ERROR",
                payload: err
            })
        }
    }
}

export function fetchTimesheets() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_TIMESHEETS_START", payload: "" })

            console.log("fetch Timesheet START")
            const res = await axios.get('/timesheets/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_TIMESHEETS_ERROR", dispatch ) ) {               
                dispatch({
                    type: "GET_TIMESHEETS",
                    payload: formatList(res.data, "timesheet_id")
                })
                dispatch({ type: "FETCH_TIMESHEETS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get timesheets list ", err);
            dispatch({ type: "FETCH_TIMESHEETS_ERROR", payload: err })
        }
    }
}

export function fetchEmployeeTimesheets() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_TIMESHEETS_START", payload: "" })

            console.log("fetch Timesheet START")
            const res = await axios.get('/timesheets/employee/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_TIMESHEETS_ERROR", dispatch ) ) {               
                dispatch({
                    type: "GET_TIMESHEETS",
                    payload: formatList(res.data, "timesheet_id")
                })
                dispatch({ type: "FETCH_TIMESHEETS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get timesheets list ", err);
            dispatch({ type: "FETCH_TIMESHEETS_ERROR", payload: err })
        }
    }
}

export function updateTimesheet(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_TIMESHEET_START", payload: "" })

            console.log("update Timesheet START")
            const res = await axios.post("/timesheets/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_TIMESHEET_ERROR", dispatch ) ) {               
				dispatch({
                    type: "UPDATE_TIMESHEET",
                    payload: data
                })
				dispatch({ type: "UPDATE_TIMESHEET_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update timesheet ", err);
            dispatch({
                type: "UPDATE_TIMESHEET_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteTimesheet(timesheet_id) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "DELETE_TIMESHEET_START", payload: "" })

            console.log("delete Timesheet START")
            const res = await axios.post("/timesheets/delete", {data: timesheet_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_TIMESHEET_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_TIMESHEET",
                    payload: timesheet_id
                })
                dispatch({ type: "DELETE_TIMESHEET_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete timesheet ", err);
            dispatch({
                type: "DELETE_TIMESHEET_ERROR",
                payload: err
            })
        }
    }
}